import { getAiBuildMeta } from 'services/ai';
import { type ExperienceBuildMetaT, useAsyncData } from 'utils';

export type UseAiBuildMetaResT = {
  steps: string[];
  title: string;
} | null;

export function useAiBuildMeta(transcript: string): UseAiBuildMetaResT {
  const res = useAsyncData(
    'experienceBuildMeta',
    (old): ExperienceBuildMetaT | Promise<ExperienceBuildMetaT> => {
      if (old?.transcript === transcript) return old;

      if (!transcript) {
        return {
          steps: [],
          title: '',
          transcript,
        };
      }

      return (async () => {
        const meta = await getAiBuildMeta({ transcript });
        return {
          steps: meta.steps,
          title: meta.title,
          transcript,
        };
      })();
    },
    {
      deps: [transcript],
    },
  );

  return res.data;
}
